import React, { useState, useEffect} from "react";
import { Dialog } from "@headlessui/react";
import Overlay from "../../UILibrary/Overlay";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchScoreCards,
  createScoreCard,
  updateScoreCard,
  deleteScoreCard,
} from "../../../store/scoreCardSlice"

const customStyles = {
  menu: (provided) => ({
    ...provided,
    textAlign: "start",
    background: "#F7F7F7",
    borderRadius: "0.5rem",
  }),
  control: (provided, state) => ({
    ...provided,
    border: "none",
    background: "#F9F9F9",
    textAlign: "start",
    height: "42px",
    borderRadius: "0.5rem",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
      : provided.boxShadow,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "black",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "lightgray"
      : state.isFocused
      ? "lightgray"
      : provided.backgroundColor,
    color: "black",
    padding: "6px",
    borderRadius: "0.5rem",
    "&:active": {
      backgroundColor: "lightgray",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "black",
  }),
};

const phases = [
  "Phases",
  "Outreach Phase",
  "Qualification Phase",
  "Evaluation Phase",
  "Onboarding Phase",
];
const phaseOptions = phases.map((phase) => ({
  value: phase === "Phases" ? "" : phase,
  label: phase,
}));

const RatingIcon = ({ active }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
  >
    <path
      d="M18.6631 12.0801C18.7726 11.9705 18.8342 11.822 18.8342 11.6671C18.8342 11.5122 18.7726 11.3636 18.6631 11.2541C18.5536 11.1445 18.405 11.083 18.2501 11.083C18.0952 11.083 17.9466 11.1445 17.8371 11.2541L13.5834 15.5089L11.6631 13.5874C11.5536 13.4779 11.405 13.4163 11.2501 13.4163C11.0952 13.4163 10.9466 13.4779 10.8371 13.5874C10.7276 13.6969 10.666 13.8455 10.666 14.0004C10.666 14.1553 10.7276 14.3039 10.8371 14.4134L13.1704 16.7467C13.2246 16.8011 13.289 16.8442 13.3598 16.8736C13.4307 16.903 13.5067 16.9181 13.5834 16.9181C13.6601 16.9181 13.7361 16.903 13.807 16.8736C13.8779 16.8442 13.9422 16.8011 13.9964 16.7467L18.6631 12.0801Z"
      fill={active ? "#3B82F6" : "black"}
    />
    <path
      d="M14.7497 23.9163C12.1196 23.9163 9.59727 22.8716 7.73753 21.0118C5.8778 19.1521 4.83301 16.6297 4.83301 13.9997C4.83301 11.3696 5.8778 8.84727 7.73753 6.98753C9.59727 5.1278 12.1196 4.08301 14.7497 4.08301C17.3797 4.08301 19.9021 5.1278 21.7618 6.98753C23.6216 8.84727 24.6663 11.3696 24.6663 13.9997C24.6663 16.6297 23.6216 19.1521 21.7618 21.0118C19.9021 22.8716 17.3797 23.9163 14.7497 23.9163ZM5.99967 13.9997C5.99967 16.3203 6.92155 18.5459 8.56249 20.1869C10.2034 21.8278 12.429 22.7497 14.7497 22.7497C17.0703 22.7497 19.2959 21.8278 20.9369 20.1869C22.5778 18.5459 23.4997 16.3203 23.4997 13.9997C23.4997 11.679 22.5778 9.45343 20.9369 7.81249C19.2959 6.17155 17.0703 5.24967 14.7497 5.24967C12.429 5.24967 10.2034 6.17155 8.56249 7.81249C6.92155 9.45343 5.99967 11.679 5.99967 13.9997Z"
      fill={active ? "#3B82F6" : "black"}
    />
  </svg>
);

export default function ScoreCardDashboard() {
  // const [cards, setCards] = useState([]);

  // const [selectedPhase, setSelectedPhase] = useState("");
    const dispatch = useDispatch();
  const { cards, loading, error } = useSelector((state) => state.scoreCard);
  const [selectedPhase, setSelectedPhase] = useState(phaseOptions[0]);
  const [editingCard, setEditingCard] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const buyerId = useSelector((state) => state.auth.id);
    const supplierId = useSelector((state) => state.auth.selectedSupplier._id);
  const [averageRatings, setAverageRatings] = useState(() => {
    const initial = {};
    phases.slice(1).forEach((phase) => {
      initial[phase] = 0;
    });
    return initial;
  });
    useEffect(() => {
    dispatch(fetchScoreCards({ buyerId, supplierId }));
  }, [dispatch]);



  const handleDelete = (id) => {
    dispatch(deleteScoreCard(id));
  };
  const handleEdit = (card) => {
    setEditingCard(card);
    setIsEditing(true);
  };

  const handleCancel = (card) => {
    setEditingCard(null);
    setIsEditing(false);
  };
const handleSave = (card) => {
  if (!card.scoreCardId) {
    const payload = {
      buyerId,
      supplierId,
      cardName: card.cardName,
      description: card.description,
      phase: card.phase,
      rating: Number(card.rating),
    };

    dispatch(createScoreCard(payload));
  } 
  else {
     const payload = {
      buyerId,
      supplierId,
      scoreCardId: card.scoreCardId,
      cardName: card.cardName,
      description: card.description,
      phase: card.phase,
      rating: Number(card.rating),
    };
    dispatch(updateScoreCard({ id: card.scoreCardId, data: payload }));
  }
      setEditingCard(null);
    setIsEditing(false);
};



  useEffect(() => {
    const newAverages = {};
    phases.slice(1).forEach(phase => {
      newAverages[phase] = calculateAverageForPhase(phase, cards);
    });
    setAverageRatings(newAverages);
  }, [cards]);
    

  const calculateAverageForPhase = (phase, cardsArray) => {
    const phaseCards = cardsArray.filter(card => card.phase === phase);
    if (phaseCards.length === 0) return 0;
  
    const total = phaseCards.reduce((sum, c) => sum + Number(c.rating || 0), 0);
    const average = total / phaseCards.length;
  
    return average;
  };
  
  

const filteredCards =
  selectedPhase.value === ""
    ? phases.slice(1).reduce((acc, phase) => {
        acc[phase] = cards.filter((card) => card && card.phase === phase);
        return acc;
      }, {})
    : {
        [selectedPhase.value]: cards.filter(
          (card) => card && card.phase === selectedPhase.value
        ),
      };



  return (
    <>
      <div className="border rounded-lg my-6 p-2">
        <span className=" flex justify-start text-left text-black font-medium">
          Average rating
        </span>
        <div className="overflow-x-auto py-4 mt-2">
          <table className="min-w-full bg-white border-gray-200 text-center">
            <thead>
              <tr className="bg-[#FAFAFA]">
                <th className="px-2 py-4 text-center align-middle">Phase</th>
                {[1, 2, 3, 4, 5].map((score) => (
                  <th key={score} className="p-2 text-center align-middle">
                    {score}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.entries(averageRatings).map(([phase, averageRating]) => {
                return (
                  <tr key={phase} className="border-t">
                    <td className="px-2 py-4 text-center align-middle">
                      <div className="flex items-center justify-center h-full text-[#1D2739] font-semibold px-2">
                        {phase}
                      </div>
                    </td>
                    {[1, 2, 3, 4, 5].map((score) => (
                      <td key={score} className="p-2 text-center align-middle">
                        <div className="flex items-center justify-center">
                          <RatingIcon
                            active={score === Math.round(averageRating)}
                          />
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex flex-row justify-between items-center mb-4 mt-8">
        <div className="flex text-black ">Phases</div>
        <div className="flex justify-end gap-2 items-center mb-4">
          <Select
            options={phaseOptions}
            value={selectedPhase}
            onChange={setSelectedPhase}
            className="w-44"
            styles={customStyles}
          />

          <button
            className="bg-[#EAF524] px-4 py-2 rounded text-black flex flex-row justify-start font-semibold"
            onClick={() => setEditingCard({ phase: selectedPhase })}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M12.1851 6.5V18.5M18.1851 12.5H6.18506"
                stroke="#1D2739"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Add score card
          </button>
        </div>
      </div>

      <div className="flex flex-wrap gap-x-6">
        {Object.entries(filteredCards).map(([phase, cardsInPhase]) => {
          if (cardsInPhase.length === 0) return null;

          return (
            <div key={phase} className="flex flex-col mb-6 w-full">
              {selectedPhase.value === "" && (
                <h2 className="text-base text-left text-black mb-3">{phase}</h2>
              )}
              <div className="flex flex-wrap gap-6">
                {cardsInPhase.map((card) => (
                  <div
                    key={card.scoreCardId}
                    className="w-[358px] border p-4 rounded-2xl shadow bg-white mb-3 text-left"
                  >
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="font-semibold">{card.cardName}</h3>
                      <button
                        onClick={() => handleEdit(card)}
                        className="text-sm text-gray-600 flex flex-row justify-start items-center gap-1 border rounded py-1 px-2"
                      >
                        Edit
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                        >
                          <path
                            d="M7.99984 3.00045L9.99984 5.00045M6.6665 12.3338H11.9998M1.33317 9.66712L0.666504 12.3338L3.33317 11.6671L11.0572 3.94312C11.3071 3.69308 11.4476 3.354 11.4476 3.00045C11.4476 2.6469 11.3071 2.30782 11.0572 2.05778L10.9425 1.94312C10.6925 1.69315 10.3534 1.55273 9.99984 1.55273C9.64628 1.55273 9.30721 1.69315 9.05717 1.94312L1.33317 9.66712Z"
                            stroke="#7B7B7B"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    <p className="text-sm text-gray-500 mb-2">
                      {card.description}
                    </p>
                    <div className="text-[#767676] mt-10 font-semibold flex flex-col text-sm">
                      Rating
                      <span className="text-[#0088FF] font-semibold text-base">
                        {card.rating}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {editingCard && (
        <>
          <Overlay />

          <Dialog
            open={!!editingCard}
            onClose={() => setEditingCard(null)}
            className="fixed z-10 inset-0 overflow-y-auto"
            style={{ zIndex: 10000 }}
          >
            <div className="flex items-center justify-center min-h-screen">
              <Dialog.Panel className="bg-white p-6 rounded shadow max-w-xl w-full h-[768px]">
                {editingCard && (
                  <>
                    <div className="flex justify-between items-center mb-12 mt-12">
                      <Dialog.Title className="text-lg font-bold">
                        {isEditing ? "Edit Card" : "Add a new card"}
                      </Dialog.Title>
                      {editingCard.scoreCardId && (
                        <button
                          type="button"
                          className="text-red-500 text-base font-semibold p-2 bg-[#FFF3F3] rounded flex flex-row gap-1 justify-center items-center"
                          onClick={() => {
                            handleDelete(editingCard.scoreCardId);
                            setEditingCard(null);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M9.82667 6.49937L9.596 12.4994M6.404 12.4994L6.17333 6.49937M12.8187 4.35937C13.0467 4.39404 13.2733 4.43071 13.5 4.47004M12.8187 4.35937L12.1067 13.6147C12.0776 13.9915 11.9074 14.3435 11.63 14.6002C11.3527 14.8569 10.9886 14.9995 10.6107 14.9994H5.38933C5.0114 14.9995 4.64735 14.8569 4.36999 14.6002C4.09262 14.3435 3.92239 13.9915 3.89333 13.6147L3.18133 4.35937M12.8187 4.35937C12.0492 4.24305 11.2758 4.15477 10.5 4.09471M3.18133 4.35937C2.95333 4.39337 2.72667 4.43004 2.5 4.46937M3.18133 4.35937C3.95076 4.24305 4.72416 4.15477 5.5 4.09471M10.5 4.09471V3.48404C10.5 2.69737 9.89333 2.04137 9.10667 2.0167C8.36908 1.99313 7.63092 1.99313 6.89333 2.0167C6.10667 2.04137 5.5 2.69804 5.5 3.48404V4.09471M10.5 4.09471C8.83581 3.96609 7.16419 3.96609 5.5 4.09471"
                              stroke="#FF0000"
                              stroke-width="1.11111"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          Delete card
                        </button>
                      )}
                    </div>

                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSave(editingCard);
                      }}
                      className="space-y-8"
                    >
                      <div>
                        <label className="block text-base font-medium text-[#1D2739]">
                          Card name
                        </label>
                        <input
                          type="text"
                          className="custom-edit-profile-input"
                          value={editingCard.cardName || ""}
                          onChange={(e) =>
                            setEditingCard({
                              ...editingCard,
                              cardName: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div>
                        <label className="block text-base font-medium text-[#1D2739]">
                          Description
                        </label>
                        <textarea
                          rows={4}
                          className="flex w-full p-4 rounded-[6.392px] border border-[#D7D7D7] bg-[#F6F6F6] resize-none text-[#767676]"
                          value={editingCard.description || ""}
                          onChange={(e) =>
                            setEditingCard({
                              ...editingCard,
                              description: e.target.value,
                            })
                          }
                        ></textarea>
                      </div>

                      <div>
                        <label className="block text-base font-medium text-[#1D2739]">
                          Phase
                        </label>
                        <Select
                          className="w-full"
                          value={phaseOptions.find(
                            (option) => option.value === editingCard.phase
                          )}
                          onChange={(selectedOption) =>
                            setEditingCard({
                              ...editingCard,
                              phase: selectedOption.value,
                            })
                          }
                          options={phaseOptions}
                          placeholder="Select Phase"
                          isSearchable={false}
                          styles={customStyles}
                        />
                      </div>

                      <div>
                        <label className="block text-base font-medium text-[#1D2739]">
                          Rating
                        </label>
                        <input
                          type="number"
                          min="0"
                          max="5"
                          step="0.1"
                          className="custom-edit-profile-input"
                          value={editingCard.rating || ""}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            if (value > 5) {
                              setEditingCard({ ...editingCard, rating: 5 });
                            } else if (value < 0) {
                              setEditingCard({ ...editingCard, rating: 0 });
                            } else {
                              setEditingCard({
                                ...editingCard,
                                rating: e.target.value,
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="flex flex-col gap-2 justify-center items-center absolute left-1/2 transform -translate-x-1/2 -translate-y-1/5">
                        <button
                          onClick={() => handleSave(editingCard)}
                          className="flex w-[432px] h-[56px] p-5 justify-center items-center rounded-[13px] bg-[#EAF524] mt-2"
                        >
                          Done
                        </button>
                        <span
                          className="text-[#7E7E7E]"
                          onClick={() => handleCancel()}
                        >
                          Cancel
                        </span>
                      </div>
                    </form>
                  </>
                )}
              </Dialog.Panel>
            </div>
          </Dialog>
        </>
      )}
    </>
  );
}
